import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
  fromDocRef
} from "angularfire2/firestore";
import { CamperVan } from "../models/campervan";
import { User } from "../models/user";
import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/toPromise";

@Injectable()
export class FireBaseService {
  camperVanCollection: AngularFirestoreCollection<CamperVan>;
  camperVans: Observable<CamperVan[]>;
  camperVanDoc: AngularFirestoreDocument<CamperVan>;

  userCollection: AngularFirestoreCollection<User>;
  users: Observable<User[]>;

  userDoc: AngularFirestoreDocument<User>;
  user: any;

  theAddedCamperVanRef;

  constructor(public db: AngularFirestore) {
    // this.camperVans = this.db.collection('CamperVans').valueChanges();

    // ------- CAMPERVAN -------------
    this.camperVanCollection = this.db.collection("campervans");

    this.camperVans = this.db
      .collection("campervans")
      .snapshotChanges()
      .map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as CamperVan;
          data.campervanId = a.payload.doc.id;
          console.log("My CamperVans Data", data);
          return data;
        });
      });

    // ------- User -------------
    this.userCollection = this.db.collection("users");

    this.users = this.db
      .collection("users")
      .snapshotChanges()
      .map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as User;
          data.uid = a.payload.doc.id;
          console.log("My User Data", data);
          return data;
        });
      });
  } // Constructor

  getCamperVans() {
    return this.camperVans;
  }

  addCamperVan(campervan: CamperVan, userId, uploadUrl, uploadName) {
    console.log("This is my campervan", campervan);
    console.log("This is my UserId", userId);
    console.log("This is my Upload Url", uploadUrl);
    console.log("This is my Upload Name", uploadName);

    campervan.userId = userId;
    campervan.imgRef.url = uploadUrl;
    campervan.imgRef.name = uploadName;
    campervan.createdAt = new Date();
    console.log("my campervan object before add to firestore", campervan);
    this.camperVanCollection
      .add(campervan)
      .then(result => {
        console.log(result);
        this.updateCamperId(result.id);
        const theAddedCamperVanRef = new AngularFirestoreDocument<any>(result);
      })
      .catch(error => console.log(error));

    console.log(this.theAddedCamperVanRef);
  }

  updateCamperId(id) {
    const userRef = this.db.doc(`campervans/${id}`);
    const data = {
      campervanId: id
    };
    return userRef.update(data);
  }

  /*.then(
    (success) => console.log(success.id),
    (err) => console.warn(err)
  );


  .then(function(docRef){
      return docRef.id;
     });


     .then(function(docRef) {
      console.log('Document written with ID: ', docRef.id);
      return docRef.id;
  })
  .catch(function(error) {
      console.error('Error adding document: ', error);
  });
  }
*/

  deleteCamperVan(campervan: CamperVan) {
    this.camperVanDoc = this.db.doc(`campervans/${campervan.campervanId}`);
    this.camperVanDoc.delete();
  }

  updateCamperVan(campervan: CamperVan) {
    console.log(campervan);
    campervan.updatedOn = new Date();
    this.camperVanDoc = this.db.doc(`campervans/${campervan.campervanId}`);
    this.camperVanDoc.update(campervan);
  }

  getUsers() {
    console.log("My Users Object", this.users);
    return this.users;
  }

  getUserDetails(id) {
    return this.db.doc<User>(`/users/${id}`);
  }

  /*getCamperVanByUserId(userId){

     this.camperVanCollection = this.db.collection<CamperVan>('campervans', ref => {
      return ref
        .where('userId', '==', userId);
    });
  }


  getallclubs() {
    return this.afs.collection('epl', ref => ref.orderBy('club')).valueChanges();
  }
 */

  getCamperVanByUserId(userId) {
    return this.db.collection<CamperVan>("campervans", ref => {
      return ref.where("userId", "==", userId);
    });
  }

  updateUserBio(userId, userBio) {
    this.db.doc(`users/${userId}`).update({
      userBio: userBio
    });
  }
} // end class

/*

 //return this.db.collection('campervans', ref => ref.where('userId', '==', userId));
    //var camperRef;
    this.camperVanCollection = this.db.collection<CamperVan>('campervan', ref => {
      return ref
        .where('user', '==', 'f3IEK2GGOie5qG04D79mDSCU4883');
    });
    this.camperVans = this.camperVanCollection.valueChanges();
    console.log(this.camperVans);
    //console.log('camperref', camperRef);

*/



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/services/firebase.service.ts